
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CertificateInterface } from '@/services/SSL/interfaces';

@Component({})
export default class ViewCertificateDialog extends Vue {
  private visible: boolean = true;
  @Prop() private readonly certificate!: CertificateInterface;

  private destroyComponent(): void {
    this.$emit('close');
  }
}
